export default __webpack_public_path__ + "static/media/icon-playstation.ba9889df.svg";